// Expressive kawaii blue crab.
export default function CartoonCrab({ className = "w-28 h-24" }) {
  return (
    <svg viewBox="0 0 240 200" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
      <defs>
        <radialGradient id="crabBodyBlue" cx="40%" cy="35%" r="70%">
          <stop offset="0%" stopColor="#7CC4FF" />
          <stop offset="60%" stopColor="#3B82F6" />
          <stop offset="100%" stopColor="#1E3A8A" />
        </radialGradient>
        <radialGradient id="crabBellyBlue" cx="50%" cy="50%" r="60%">
          <stop offset="0%" stopColor="#DBEAFE" />
          <stop offset="100%" stopColor="#BFDBFE" />
        </radialGradient>
        <radialGradient id="crabClawBlue" cx="30%" cy="30%" r="70%">
          <stop offset="0%" stopColor="#93C5FD" />
          <stop offset="100%" stopColor="#2563EB" />
        </radialGradient>
        <radialGradient id="crabEyeBlue" cx="35%" cy="35%" r="65%">
          <stop offset="0%" stopColor="#FBBF24" />
          <stop offset="60%" stopColor="#F59E0B" />
          <stop offset="100%" stopColor="#92400E" />
        </radialGradient>
      </defs>
      <style>{`
        .crab-leg-l1 { animation: legL1 0.4s ease-in-out infinite; transform-origin: 95px 145px; }
        .crab-leg-l2 { animation: legL2 0.4s ease-in-out infinite; transform-origin: 85px 148px; }
        .crab-leg-l3 { animation: legL3 0.4s ease-in-out infinite; transform-origin: 75px 148px; }
        .crab-leg-r1 { animation: legR1 0.4s ease-in-out infinite; transform-origin: 145px 145px; }
        .crab-leg-r2 { animation: legR2 0.4s ease-in-out infinite; transform-origin: 155px 148px; }
        .crab-leg-r3 { animation: legR3 0.4s ease-in-out infinite; transform-origin: 165px 148px; }
        .crab-claw-l { animation: clawL 0.6s ease-in-out infinite; transform-origin: 60px 70px; }
        .crab-claw-r { animation: clawR 0.6s ease-in-out infinite; transform-origin: 180px 70px; }
        .crab-pincer-l { animation: pincerL 0.6s ease-in-out infinite; transform-origin: 50px 55px; }
        .crab-pincer-r { animation: pincerR 0.6s ease-in-out infinite; transform-origin: 190px 55px; }
        .crab-eye { animation: blink 3.5s ease-in-out infinite; transform-origin: center; transform-box: fill-box; }
        .crab-body { animation: bodyBob 0.4s ease-in-out infinite; transform-origin: 120px 100px; }
        .crab-sparkle { animation: sparkle 2s ease-in-out infinite; transform-origin: center; transform-box: fill-box; }
        @keyframes legL1 { 0%,100% { transform: rotate(0deg) translateY(0); } 50% { transform: rotate(-15deg) translateY(-2px); } }
        @keyframes legL2 { 0%,100% { transform: rotate(0deg) translateY(0); } 50% { transform: rotate(12deg) translateY(-2px); } }
        @keyframes legL3 { 0%,100% { transform: rotate(0deg) translateY(0); } 50% { transform: rotate(-12deg) translateY(-2px); } }
        @keyframes legR1 { 0%,100% { transform: rotate(0deg) translateY(0); } 50% { transform: rotate(15deg) translateY(-2px); } }
        @keyframes legR2 { 0%,100% { transform: rotate(0deg) translateY(0); } 50% { transform: rotate(-12deg) translateY(-2px); } }
        @keyframes legR3 { 0%,100% { transform: rotate(0deg) translateY(0); } 50% { transform: rotate(12deg) translateY(-2px); } }
        @keyframes clawL { 0%,100% { transform: rotate(0deg); } 50% { transform: rotate(-5deg); } }
        @keyframes clawR { 0%,100% { transform: rotate(0deg); } 50% { transform: rotate(5deg); } }
        @keyframes pincerL { 0%,100% { transform: rotate(0deg); } 50% { transform: rotate(-12deg); } }
        @keyframes pincerR { 0%,100% { transform: rotate(0deg); } 50% { transform: rotate(12deg); } }
        @keyframes blink { 0%,91%,100% { transform: scaleY(1); } 93%,96% { transform: scaleY(0.1); } }
        @keyframes bodyBob { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-3px); } }
        @keyframes sparkle { 0%,100% { opacity: 0.9; transform: scale(1); } 50% { opacity: 0.4; transform: scale(0.85); } }
      `}</style>

      {[
        { cls: "crab-leg-l1", d: "M 95 140 Q 80 152 75 165", x: 75, y: 165 },
        { cls: "crab-leg-l2", d: "M 85 142 Q 65 155 55 168", x: 55, y: 168 },
        { cls: "crab-leg-l3", d: "M 75 142 Q 50 155 38 170", x: 38, y: 170 },
        { cls: "crab-leg-r1", d: "M 145 140 Q 160 152 165 165", x: 165, y: 165 },
        { cls: "crab-leg-r2", d: "M 155 142 Q 175 155 185 168", x: 185, y: 168 },
        { cls: "crab-leg-r3", d: "M 165 142 Q 190 155 202 170", x: 202, y: 170 },
      ].map((leg) => (
        <g key={leg.cls} className={leg.cls}>
          <path d={leg.d} stroke="#1E3A8A" strokeWidth="8" strokeLinecap="round" fill="none" />
          <circle cx={leg.x} cy={leg.y} r="5" fill="#1E3A8A" />
        </g>
      ))}

      <g className="crab-body">
        <g className="crab-claw-l">
          <path d="M 90 90 Q 70 65 55 50" stroke="url(#crabClawBlue)" strokeWidth="14" strokeLinecap="round" fill="none" />
          <circle cx="70" cy="65" r="8" fill="url(#crabClawBlue)" stroke="#1E3A8A" strokeWidth="1" />
          <g className="crab-pincer-l">
            <ellipse cx="50" cy="42" rx="22" ry="26" fill="url(#crabClawBlue)" stroke="#1E3A8A" strokeWidth="2" />
            <path d="M 38 28 Q 30 18 42 12 Q 56 14 60 24 L 56 32 Q 48 26 40 30 Z" fill="url(#crabClawBlue)" stroke="#1E3A8A" strokeWidth="2" />
            <ellipse cx="44" cy="35" rx="6" ry="9" fill="#BFDBFE" opacity="0.8" />
            <circle cx="55" cy="48" r="2" fill="#BFDBFE" opacity="0.8" />
            <path d="M 38 42 Q 50 38 62 42" stroke="#1E3A8A" strokeWidth="1.5" fill="none" />
          </g>
        </g>
        <g className="crab-claw-r">
          <path d="M 150 90 Q 170 65 185 50" stroke="url(#crabClawBlue)" strokeWidth="14" strokeLinecap="round" fill="none" />
          <circle cx="170" cy="65" r="8" fill="url(#crabClawBlue)" stroke="#1E3A8A" strokeWidth="1" />
          <g className="crab-pincer-r">
            <ellipse cx="190" cy="42" rx="22" ry="26" fill="url(#crabClawBlue)" stroke="#1E3A8A" strokeWidth="2" />
            <path d="M 202 28 Q 210 18 198 12 Q 184 14 180 24 L 184 32 Q 192 26 200 30 Z" fill="url(#crabClawBlue)" stroke="#1E3A8A" strokeWidth="2" />
            <ellipse cx="196" cy="35" rx="6" ry="9" fill="#BFDBFE" opacity="0.8" />
            <circle cx="185" cy="48" r="2" fill="#BFDBFE" opacity="0.8" />
            <path d="M 178 42 Q 190 38 202 42" stroke="#1E3A8A" strokeWidth="1.5" fill="none" />
          </g>
        </g>

        <ellipse cx="120" cy="115" rx="56" ry="40" fill="url(#crabBodyBlue)" stroke="#1E3A8A" strokeWidth="2.5" />
        <circle cx="92" cy="98" r="3" fill="#BFDBFE" opacity="0.7" />
        <circle cx="100" cy="115" r="2" fill="#BFDBFE" opacity="0.7" />
        <circle cx="142" cy="100" r="2.5" fill="#BFDBFE" opacity="0.7" />
        <circle cx="152" cy="118" r="3" fill="#BFDBFE" opacity="0.7" />
        <ellipse cx="105" cy="92" rx="18" ry="6" fill="#DBEAFE" opacity="0.7" />
        <ellipse cx="120" cy="138" rx="40" ry="14" fill="url(#crabBellyBlue)" opacity="0.85" />

        <ellipse cx="100" cy="98" rx="16" ry="20" fill="#FFFFFF" stroke="#1E3A8A" strokeWidth="2.5" />
        <ellipse cx="140" cy="98" rx="16" ry="20" fill="#FFFFFF" stroke="#1E3A8A" strokeWidth="2.5" />
        <g className="crab-eye">
          <ellipse cx="102" cy="102" rx="11" ry="14" fill="url(#crabEyeBlue)" />
          <ellipse cx="142" cy="102" rx="11" ry="14" fill="url(#crabEyeBlue)" />
          <ellipse cx="102" cy="105" rx="6" ry="8" fill="#1A0E00" />
          <ellipse cx="142" cy="105" rx="6" ry="8" fill="#1A0E00" />
          <ellipse cx="106" cy="98" rx="3.5" ry="4.5" fill="#FFFFFF" />
          <ellipse cx="146" cy="98" rx="3.5" ry="4.5" fill="#FFFFFF" />
          <circle cx="98" cy="108" r="1.8" fill="#FFFFFF" opacity="0.9" />
          <circle cx="138" cy="108" r="1.8" fill="#FFFFFF" opacity="0.9" />
        </g>
        <path d="M 87 79 Q 96 74 110 78" stroke="#1E3A8A" strokeWidth="2.5" fill="none" strokeLinecap="round" />
        <path d="M 130 78 Q 144 74 153 79" stroke="#1E3A8A" strokeWidth="2.5" fill="none" strokeLinecap="round" />
        <ellipse cx="88" cy="120" rx="8" ry="5" fill="#F472B6" opacity="0.55" />
        <ellipse cx="152" cy="120" rx="8" ry="5" fill="#F472B6" opacity="0.55" />

        <path d="M 102 122 Q 120 142 138 122 Q 130 135 120 137 Q 110 135 102 122 Z" fill="#1A1A1A" stroke="#1E3A8A" strokeWidth="2" />
        <ellipse cx="120" cy="132" rx="9" ry="4.5" fill="#FF6B8A" />
        <rect x="113" y="122" width="4.5" height="5" rx="1" fill="#FFFFFF" />

        <g className="crab-sparkle">
          <path d="M 134 92 L 136 88 L 138 92 L 142 94 L 138 96 L 136 100 L 134 96 L 130 94 Z" fill="#FFFFFF" opacity="0.9" />
        </g>
      </g>
    </svg>
  );
}
